import React, { FC, VFC, useEffect, useState } from 'react';
import { ReactComponent as PetDog } from '@/assets/img/v2/pet-dog-default-icon.svg';
import { ReactComponent as PetCat } from '@/assets/img/v2/pet-cat-default-icon.svg';
import { Dropdown } from 'react-bootstrap';
import { Pet } from '../types';
import { PetInfoDropDownItem } from './PetInfoDropDownItem';
import './BoardingPetInfo.scss';
type BoardingPetInfoProps = {
  data?: Pet[];
  accomodationType?: string;
};
const BoardingPetInfo = ({ data, accomodationType }: BoardingPetInfoProps) => {
  return (
    <div className={`pet-boarding-info`}>
      <div className="pet-profile">
        {data?.map((pet, index) => index < 2 && (
          <span className="pet-icon-bg">
            {pet?.petsImageUrl ? (
              <img src={pet?.petsImageUrl} alt="pet icon" />
            ) : pet?.petType?.toLowerCase() == 'cat' ? (
              <PetCat />
            ) : (
              <PetDog />
            )}
          </span>
        ))}
      </div>
      <div className="pet-details">
        {data?.length && data.length == 1 ? (
          <p className="pet-name">{data[0].name}</p>
        ) : data && data?.length > 1 ? (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon">
              <p className="total-pets">{data?.length} pet bookings</p>
            </Dropdown.Toggle>
            <Dropdown.Menu className="border-2 dark:border-gray-800">
              {data?.map((pet: any) => (
                <Dropdown.Item>
                  <PetInfoDropDownItem data={pet} />
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <></>
        )}
        <div className="accomodation-type">{accomodationType}</div>
      </div>
    </div>
  );
};
export default BoardingPetInfo;
